module.exports = __webpack_public_path__ + "img/sea cards - ports.f1700d46.webp";